__turbopack_context__.v({
  "active": "Stepper-module__13AbTa__active",
  "completed": "Stepper-module__13AbTa__completed",
  "filledOrange": "Stepper-module__13AbTa__filledOrange",
  "inactive": "Stepper-module__13AbTa__inactive",
  "label": "Stepper-module__13AbTa__label",
  "labelActive": "Stepper-module__13AbTa__labelActive",
  "labelCompleted": "Stepper-module__13AbTa__labelCompleted",
  "line": "Stepper-module__13AbTa__line",
  "lineCompleted": "Stepper-module__13AbTa__lineCompleted",
  "lineHalfway": "Stepper-module__13AbTa__lineHalfway",
  "lineInactive": "Stepper-module__13AbTa__lineInactive",
  "mobileProgressBackground": "Stepper-module__13AbTa__mobileProgressBackground",
  "mobileProgressContainer": "Stepper-module__13AbTa__mobileProgressContainer",
  "mobileProgressFill": "Stepper-module__13AbTa__mobileProgressFill",
  "progressBar": "Stepper-module__13AbTa__progressBar",
  "step": "Stepper-module__13AbTa__step",
  "stepContainer": "Stepper-module__13AbTa__stepContainer",
});
